import { render } from "./DataplantCreationStepFooter.vue?vue&type=template&id=df8bbeb4&lang=pug"
import script from "./DataplantCreationStepFooter.vue?vue&type=script&lang=js"
export * from "./DataplantCreationStepFooter.vue?vue&type=script&lang=js"

import "./DataplantCreationStepFooter.vue?vue&type=style&index=0&id=df8bbeb4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__